<template>
    <div>
         <!-- modal -->
    <b-modal id="lawCounterPartyAttorneyFormModal" centered size="lg" no-close-on-backdrop ref="lawCounterPartyAttorneyFormModal" :title=" $t('lawCounterPartyAttorney.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                 <b-col class="col-lg-8">
                <b-form>
                <label for="law-counter-party-attorney-name-input">{{ $t('lawCounterPartyAttorney.type') }}</label>
                     <b-form-group>
                             <validation-provider #default="{ errors }" :name=" $t('lawCounterParty.type')" rules="required">
                              <b-form-input id="law-counter-party-attorney-name-input" v-model="name" size="sm" maxlength="50" :state="errors.length > 0 ? false:null" />
                              <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                     </b-form-group>
                  </b-form>
                 </b-col>
                 <b-col class="col-lg-4">
                    <b-form>
                         <label for="law-counter-party-country-input">{{ $t('lawCounterPartyAttorney.country') }}</label>
                          <b-form-group>
                            <b-form-select  id="law-counter-party-country-input" size="sm" v-model="countrySelect" value-field="id" text-field="name" :options="countryOptions" />
                        </b-form-group>
                    </b-form>
                 </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-8">
                    <b-form>
                         <label for="law-counter-party-attorney-email-input">{{ $t('lawCounterPartyAttorney.email') }}</label>
                         <b-form-group>
                             <b-form-input id="law-counter-party-attorney-email-input" v-model="email" size="sm" maxlength="50" />
                         </b-form-group>
                    </b-form>
                </b-col>
                 <b-col class="col-lg-4">
                    <b-form>
                         <label for="law-counter-party-attorney-phone-input">{{ $t('lawCounterPartyAttorney.phone') }}</label>
                         <b-form-group>
                             <b-form-input id="law-counter-party-attorney-email-input" v-model="telephone" size="sm" maxlength="20" />
                         </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <b-form>
                        <label for="law-counter-party-attorney-entity-name-input">{{ $t('lawCounterPartyAttorney.entityName') }}</label>
                            <b-form-group>
                              <b-form-input id="law-counter-party-attorney-entity-name-input" v-model="entityName" size="sm" maxlength="150" />
                            </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                   <b-form>
                    <label for="law-counter-party-address-input">{{ $t('lawCounterPartyAttorney.address') }}</label>
                     <b-form-group>
                         <b-form-input id="law-counter-party-address-input" v-model="address" size="sm" maxlength="250" />
                     </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
              <b-row>
                   <b-col class="col-lg-12">
                        <label for="law-counter-party-note-input">{{ $t('lawCounterPartyAttorney.note') }}</label>
                        <b-form-textarea id="law-counter-party-note-input" :placeholder=" $t('lawCounterPartyAttorney.note')" rows="3" v-model="note" maxlength="250" />
                    </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
    </div>
</template>

<script>
import { email } from 'vee-validate/dist/rules';


export default {
    props: {
        getLawCounterPartyAttorneyList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            name: '',
            countryOptions: [],
            countrySelect: 0,
            address: '',
            note: '',
            entityName: '',
            telephone: '',
            email: ''
        }
    },
    methods: {
        async showInfo(id,countryId) {
            await this.$refs['lawCounterPartyAttorneyFormModal'].show()
            this.id = id
            const data = {   id: this.id  }
            const controller = {  name: 'LawCounterPartyAttorney' }
            const payload = { data: data,controller: controller}
                
            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.name = response.data.lawCounterPartyAttorney.name
                    this.address = response.data.lawCounterPartyAttorney.address
                    this.note = response.data.lawCounterPartyAttorney.note
                    this.entityName = response.data.lawCounterPartyAttorney.entityName
                    this.telephone = response.data.lawCounterPartyAttorney.telephone
                    this.email = response.data.lawCounterPartyAttorney.email
                    this.countryOptions = response.data.countries
                    this.countryOptions.splice(0, 0, this.$nullSelected())
                    if(!countryId) this.countrySelect = this.countryOptions[0].id
                    else
                    this.countrySelect = countryId
                } else {
                    this.$bvModal.hide('lawCounterPartyAttorneyFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
           
        },
        async addOrUpdate() {
            const data = {
                id: this.id,
                name: this.name,
                address: this.address,
                entityName: this.entityName,
                email: this.email,
                telephone: this.telephone,
                note: this.note,
                countryId: this.countrySelect
            }
            const controller = {  name: 'LawCounterPartyAttorney' }
            const payload = {    data: data,controller: controller}
            
            const success = await this.$refs.simpleRules.validate()
                if (success) {
                    const response = await this.$store.dispatch('moduleAuth/save', payload)
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawCounterPartyAttorneyFormModal')
                            this.getLawCounterPartyAttorneyList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                }
        },
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
